var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-progress-circular',{attrs:{"size":60,"value":(_vm.time / _vm.time_seconds) * 100,"width":7,"color":_vm.currentColor}},[_vm._v(" "+_vm._s(_vm.format_seconds_to_minutes(_vm.time))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }